import React from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import translate from '../../../../translate';
import CardImageBanner from '../../../Landing2.0/assets/images/Tarjetas.png';
import CoinsCardBanner from '../../../Landing2.0/assets/images/figuras.png';
import CarouselPricesOld from '../../../Landing/pages/components/Banner/components/carousel';
import './bannerCard.css';

const BannerCard = ({...props}) => {
  const {lan} = props;
  const transl = translate[lan].LandingCard.banner;
  return(
    <>
      <div className='background-card'>
        <div className='background-card-half-moon'>
          <div className='float-figures'>
            <Container className='wrapper-banner-card'>
              <Row>
                <Col xl={12} className='align-banner-card-image'>
                  <Image src={CardImageBanner} alt='imagen' className='card-banner-image'/>
                </Col>
                <Col xl={12} className='align-banner-card-title'>
                  <h1 className='banner-card-title'>{transl.title}</h1>
                </Col>
                <Col xl={12} className='align-banner-card-title'>
                  <h1 className='banner-card-subtitle'>{transl.subtitle}</h1>
                </Col>
                <Col xl={12} className='align-banner-card-title'>
                  <Button className='request-card-btn pulse' onClick={()=>window.open(window.location.origin + '/register','_blank')}>{transl.request_Card}</Button>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
      <CarouselPricesOld/>
    </>
  );
}

export default BannerCard;